<template>
  <li class="tree__item tree__item--parent sidebar-nav-group">
    <div class="tree__action sidebar__action">
      <a class="tree__link" @click="toggle">
        <i class="tree__icon" :class="icon"></i>
        <span class="tree__link-text">
          <span class="sidebar__item-name">{{ title }}</span>
        </span>
        <i
          class="tree__icon tree__icon--right sidebar-nav-group__chevron"
          :class="
            collapsed ? 'iconoir-nav-arrow-right' : 'iconoir-nav-arrow-down'
          "
        ></i>
      </a>
    </div>
    <div v-if="!collapsed" class="sidebar-nav-group__body">
      <slot></slot>
    </div>
  </li>
</template>

<script>
export default {
  name: 'SidebarNavGroup',
  props: {
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: 'iconoir-folder',
    },
    count: {
      type: Number,
      default: 0,
    },
    defaultCollapsed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      collapsed: this.defaultCollapsed,
    }
  },
  watch: {
    defaultCollapsed(value) {
      this.collapsed = value
    },
  },
  methods: {
    toggle() {
      this.collapsed = !this.collapsed
    },
  },
}
</script>
